import { render, staticRenderFns } from "./documentTabs.vue?vue&type=template&id=a355ea2a&scoped=true"
import script from "./documentTabs.vue?vue&type=script&lang=js"
export * from "./documentTabs.vue?vue&type=script&lang=js"
import style0 from "./documentTabs.vue?vue&type=style&index=0&id=a355ea2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a355ea2a",
  null
  
)

export default component.exports